<template>
  <div class="dinema-detail-head" v-if="!movieStore.waiting && movieStore.movie != null">
    <CRow class="w-100 mx-0 px-0">
      <CCol xs="12" class="mx-0 px-0">
        <img :src="movieStore.movie.backdrop_image" class="back-image" />
        <img :src="movieStore.movie.poster_image" class="front-image" />
      </CCol>
    </CRow>
    <CRow class="w-100 mx-0 px-3">
      <CCol xs="12" class="mx-0 mt-4 px-0 text-start detail-title">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <strong class="text-start">{{movieStore.movie.movie_name}}</strong>
      </CCol>
      <CCol xs="12" class="mx-0 mt-3 px-0 text-start detail-title">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <small>{{getReleaseYear(movieStore.movie.movie_year)}}</small>
      </CCol>
      <CCol xs="12" class="mx-0 mt-3 px-0 text-start detail-title">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <loading-view v-if="genreStore.waiting" />
        <a :href="getGenreUrl(genre)" class="link-normalize" target="_blank" v-for="genre in genreStore.genres" v-bind:key="genre.id">
          <CBadge color="light" shape="pill" class="mx-1 mt-1 text-dark">{{genre.genres.category_name}}</CBadge>
        </a>
      </CCol>
      <CCol xs="12" class="mx-0 mt-3 px-0 text-start detail-overview">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <p>{{movieStore.movie.description}}</p>
      </CCol>
      <CCol xs="12" class="mx-0 mt-3 px-0 text-start">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <CButton
            color="light"
            variant="ghost"
            class="px-0"
            @click="getCasts"
            v-if="!collapseOpen"
          >
            <u>View cast</u>

        </CButton>
        <CButton
            color="light"
            variant="ghost"
            class="px-0"
            v-if="collapseOpen"
            @click="collapseOpen = false"
          >
            <u>Hide cast</u>

        </CButton>
        <CCollapse :visible="collapseOpen">
          <loading-view v-if="actorStore.waiting" />
          <CListGroup flush>
            <CListGroupItem v-for="actor in actorStore.actors" v-bind:key="actor.id"><a :href="getUrl(actor.casts)" class="link-normalize" target="_blank">{{actor.casts.actor_name}} <hr class="border border-bottom border-light my-0 py-0"></a></CListGroupItem>
          </CListGroup>
        </CCollapse>
      </CCol>
      <CCol xs="12" class="mx-0 mt-3 px-0 text-start">
        <!-- <img src="https://image.tmdb.org/t/p/w500/6mJrgL7Mi13XjJeGYJFlD6UEVQw.jpg" class="back-image" /> -->
        <CButton
            color="light"
            shape="pill"
            class="w-100 py-3 btn-download"
            @click="openDownloadLink(movieStore.movie.download_link)"
          >
            <strong>Download</strong>
        </CButton>
      </CCol>
  </CRow>
  </div>
</template>
<script>
import { useMovieStore } from '../../stores/movie'
import { useActorStore } from '../../stores/actor'
import { useGenreStore } from '../../stores/genre'

import LoadingView from './../../components/LoadingView.vue'

export default {
  name: 'MovieListView',
  components: {
    LoadingView
  },
  setup () {
    const movieStore = useMovieStore()
    const actorStore = useActorStore()
    const genreStore = useGenreStore()
    const pages = []
    return {
      movieStore,
      actorStore,
      genreStore,
      pages
    }
  },
  data () {
    return {
      collapseOpen: false
    }
  },
  methods: {
    goto (page) {
      this.movieStore.fetchData(page)
      this.$refs.content.scrollTop = 0
    },
    openDownloadLink (link) {
      window.open(link, '_blank').focus()
    },
    getCasts () {
      this.collapseOpen = true
      this.actorStore.fetchData(this.movieStore.movie.id)
    },
    getGenreUrl (genre) {
      var routeData = this.$router.resolve({ name: 'movie-by-genre', query: { genreTag: genre.genres.id, genreName: genre.genres.category_name } })
      return routeData.href
    },
    getUrl (cast) {
      var routeData = this.$router.resolve({ name: 'movie-by-actor', query: { actorTag: cast.id, actorName: cast.actor_name } })
      return routeData.href
    },
    getReleaseYear (value) {
      if (value == null) {
        return ''
      }
      return this.moment(value).year()
    }
  },
  mounted () {
    console.log('movie mounted')
    var target = this.$route.query.target

    if (target === undefined) {
      this.$router.push({ name: 'movie-list' })
    }
    // var currentPage = 1
    // if (this.$route.query.page !== undefined) { currentPage = this.$route.query.page }
    // console.log(currentPage)
    // this.movieStore.fetchData(currentPage)
    this.movieStore.fetchDataById(target)
    this.genreStore.fetchData(target)
  }
}
</script>
